import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../view/home.vue'),
  },
	{
	  path: '/brand',
	  name: 'brand',
	  component: () => import('../view/brand.vue'),
	},
	{
	  path: '/AI',
	  name: 'AI',
	  component: () => import('../view/AI.vue'),
	},
	{
	  path: '/brands',
	  name: 'brands',
	  component: () => import('../view/brands.vue'),
	},
	{
	  path: '/product',
	  name: 'product',
	  component: () => import('../view/product.vue'),
	},
	{
	  path: '/service',
	  name: 'service',
	  component: () => import('../view/service.vue'),
	},
	{
	  path: '/news',
	  name: 'news',
	  component: () => import('../view/news.vue'),
	},
	{
	  path: '/contact',
	  name: 'contact',
	  component: () => import('../view/contact.vue'),
	},
	{
	  path: '/declares',
	  name: 'declares',
	  component: () => import('../view/declares.vue'),
	},
	{
	  path: '/newDetail',
	  name: 'newDetail',
	  component: () => import('../view/newDetail.vue'),
	}
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.afterEach(() => {
  window.scrollTo(0, 0); // 切换路由之后滚动条始终在最顶部
});

export default router
